import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const TakeawayIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
            <Path
                fill={color}
                fillRule="evenodd"
                d="m5.595 10.49.87-3.183c.038-.142.065-.254.142-.384a.93.93 0 0 1 .448-.389c1.064-.436 2.13-.895 3.198-1.318q.142-.054.292-.07c.792-.077 1.494.736 1.258 1.544l-.857 3.088c-.133.474-.36 1.037-.412 1.533a.2.2 0 0 0 .005.08c.04.13.203.258.297.351.476.473 1.525 1.097 1.879 1.732a1 1 0 0 1 .113.35c.173 1.36.386 2.761.524 4.12.052.517-.306.98-.799 1.048a.91.91 0 0 1-.83-.338.97.97 0 0 1-.205-.486l-.497-3.749c-.895-.81-2.444-1.802-2.79-3.028a1.6 1.6 0 0 1-.057-.498c.015-.356.13-.693.232-1.036.205-.691.417-1.383.62-2.074l-.866.356-.784 2.87c-.164.605-.879.91-1.413.53a.98.98 0 0 1-.368-1.05m-.491 7.068 2.809-5.69c.13.283.306.535.51.77.244.285.52.535.797.785l-2.466 5.004a.91.91 0 0 1-1.403.315c0-.01-.57-.487-.258-1.162zM11.33 1c.98 0 1.772.822 1.772 1.835 0 1.014-.793 1.835-1.772 1.835-.978 0-1.772-.821-1.772-1.835C9.558 1.822 10.352 1 11.33 1m.067 8.842.57-1.937 2.646 1.966q.105.077.184.18a.986.986 0 0 1-.03 1.234.903.903 0 0 1-1.232.145z"
                clipRule="evenodd"
            />
        </Svg>
    )
}

export default TakeawayIcon
